export default __webpack_public_path__ + "static/media/btn_big_avalanche.451fe0f3.png";